var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_335_1437)" } }, [
        _c("path", {
          attrs: {
            d: "M8.80714 0.293945C8.36071 -0.0966797 7.63571 -0.0966797 7.18929 0.293945L2.61786 4.29395C2.17143 4.68457 2.17143 5.31895 2.61786 5.70957C3.06429 6.1002 3.78929 6.1002 4.23571 5.70957L6.85714 3.41582V10.0002C6.85714 10.5533 7.36786 11.0002 8 11.0002C8.63214 11.0002 9.14286 10.5533 9.14286 10.0002V3.41582L11.7643 5.70957C12.2107 6.1002 12.9357 6.1002 13.3821 5.70957C13.8286 5.31895 13.8286 4.68457 13.3821 4.29395L8.81071 0.293945H8.80714ZM2.28571 11.0002C2.28571 10.4471 1.775 10.0002 1.14286 10.0002C0.510714 10.0002 0 10.4471 0 11.0002V13.0002C0 14.6564 1.53571 16.0002 3.42857 16.0002H12.5714C14.4643 16.0002 16 14.6564 16 13.0002V11.0002C16 10.4471 15.4893 10.0002 14.8571 10.0002C14.225 10.0002 13.7143 10.4471 13.7143 11.0002V13.0002C13.7143 13.5533 13.2036 14.0002 12.5714 14.0002H3.42857C2.79643 14.0002 2.28571 13.5533 2.28571 13.0002V11.0002Z",
            fill: "black",
            "fill-opacity": "0.88",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_335_1437" } }, [
          _c("rect", { attrs: { width: "16", height: "16", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }